import React from 'react'
import UploadFile from '../comparison/UploadFile'

const adminContentStyle = {
    flex: 1,
    boxSizing: 'border-box',
    paddingTop: 12,
    paddingRight: 20,
    paddingBottom: 20,
    paddingLeft: 20,
    overflow: 'auto',
};

const AdminPage = () => {
    return (
        <div style={adminContentStyle}>
            <UploadFile />
        </div>
    )
}

export default AdminPage